import script from "./DocumentSurveyView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentSurveyView.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentSurveyView.vue?vue&type=style&index=0&id=3cc30f89&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cc30f89"]])

export default __exports__